export default "__VITE_ASSET__a88d06ce__"